export class SpinnerEvent {
  spin: boolean;
  message: string;

  constructor(spin?: boolean, message?: string) {
    this.spin = spin === true;
    this.message = message;
  }
}
